import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import useFetch from '../../react-hooks/use-fetch';
import EventListingItem from './event-listing-item';

const EventListingModule = props => {
  const { response, isLoading } = useFetch({ url: props.api });
  const list = response?.data?.body?.list;
  const $eloquaModal = useMemo(
    () => document.getElementById(props.gatedModalId),
    [props.gatedModalId]
  );
  const elem = useRef({});
  let ctaClassName = '';

  switch (props.ctaType) {
    case 'primary-external':
      ctaClassName = 'event-listing__cta btn btn--primary external';
      break;

    case 'secondary':
      ctaClassName = 'event-listing__cta btn btn--secondary';
      break;

    case 'secondary-external':
      ctaClassName = 'event-listing__cta btn btn--secondary external';
      break;

    case 'ternary':
      ctaClassName =
        'event-listing__cta link link--primary link--with-arrow event-listing-item__cta';
      break;

    default:
      ctaClassName = 'event-listing__cta btn btn--primary';
      break;
  }
  return (
    <div ref={elem}>
      {props.moduleTitle && props.moduleTitle.length ? (
        <h2
          className="event-listing__title"
          dangerouslySetInnerHTML={{ __html: props.moduleTitle }}
        />
      ) : null}
      {!isLoading && !list?.length && (
        <div
          className="rte_wrapper basic-rte event-listing__items"
          dangerouslySetInnerHTML={{ __html: props.noResultsHtml }}
        />
      )}
      {list && list?.length ? (
        <ul className="event-listing__items">
          {list.map(item => (
            <EventListingItem
              key={item.id}
              labelRegister={props.labelRegister}
              labelPersons={props.labelPersons}
              modal={$eloquaModal}
              {...item}
            />
          ))}
        </ul>
      ) : null}
      {props.ctaText && props.ctaText.length ? (
        <div className="event-listing__cta-container">
          <a href={props.ctaUrl} className={ctaClassName}>
            <svg className="btn__icon" width="20" height="20">
              <use xlinkHref="#external" />
            </svg>
            <span>{props.ctaText}</span>
          </a>
        </div>
      ) : null}
    </div>
  );
};

EventListingModule.propTypes = {
  labelRegister: PropTypes.string,
  labelPersons: PropTypes.string
};

export default EventListingModule;
